export default "__VITE_ASSET__Dh6LQJmm__";